<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 pt-0 pt-md-1 pt-xl-0 pb-3 px-0 px-sm-2 shadow-lg col-12 col-lg-11"
>
  <div class="jumbotron-fluid mx-0 px-0 mb-0 pb-1 col-md-12 col-lg-11">
    <div class="container mt-2 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Micro Loans
          </h3>
        </div>
      </div>
    </div>
    <div
      class="invest-card card-body mt-2 py-4 mb-5 mx-0 mx-sm-auto px-1 px-lg-auto shadow-lg"
      [hidden]="txnsApprovals.length !== 0"
    >
      <div class="row">
        <div class="col-12">
          <h5 class="rub-head4 text-center font-weight-bold py-1">
            There are no Micro Loans to approve
          </h5>
        </div>
      </div>
    </div>
    <div
      class="invest-card card-body my-2 py-3 px-2 shadow-lg"
      [hidden]="txnsApprovals.length === 0"
    >
      <form [formGroup]="userForm">
        <div class="item-header mb-2">
          <div class="row">
            <!--select all items-->
            <div class="col-12 ml-0 pl-0 mx-sm-auto px-sm-auto pt-1">
              <input
                id="allSelected"
                formControlName="selectAll"
                (click)="checkAllItems(!fval.selectAll.value)"
                type="checkbox"
                value=""
                class="ml-4 text-info"
                tooltip="Select All"
              />
              Select All
            </div>
          </div>
        </div>
        <div class="iteration mb-2" formArrayName="txnApprovals">
          <div
            class="item-container my-1"
            *ngFor="let items of fval.txnApprovals['controls']; let idx = index"
          >
            <div
              class="list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
              [formGroupName]="idx"
            >
              <div class="list-card-body card-body my-0 py-0 mx-0">
                <div class="row my-0 py-0">
                  <div class="col-1 mx-0 px-0">
                    <!--select an item-->
                    <input
                      formControlName="approved"
                      (click)="deselectAll(idx)"
                      type="checkbox"
                      value=""
                      class="ml-1 text-info"
                    />
                  </div>
                  <div class="col-11">
                    <div class="row mx-md-0 px-md-0">
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div class="col-3 d-flex justify-content-start">
                            <span class="">Client:</span>
                          </div>
                          <div
                            class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0"
                          >
                            <span class="itemCreated">
                              {{
                                fval.txnApprovals["controls"][idx]["controls"].client.value
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-3">
                        <div class="row">
                          <div
                            class="col-3 col-xl-4 d-flex justify-content-start"
                          >
                            <span class="">Amount:</span>
                          </div>
                          <div
                            class="col-9 col-xl-8 d-flex justify-content-start font-weight-bold mx-0 px-0"
                          >
                            <span class="itemCreated">
                              {{
                                fval.txnApprovals["controls"][idx]["controls"].amount.value ?
                                  (fval.txnApprovals["controls"][idx]["controls"].amount.value | currency: "UGX ")
                                    : (0 | currency: "UGX ")
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-10 col-md-8 col-xl-4">
                        <div class="row">
                          <div class="col-3 d-flex justify-content-start">
                            <span class="">Purpose:</span>
                          </div>
                          <div
                            class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-md-0"
                          >
                            <span class="itemCreated">
                              {{
                                fval.txnApprovals["controls"][idx]["controls"].purpose.value
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-2 col-md-4 col-xl-1 justify-content-end font-weight-bold mx-0 px-0"
                      >
                        <a class="text-dark pointerCursor">
                          <span
                            class="itemCreated"
                            (click)="
                              openModal(
                                template,
                                fval.txnApprovals['controls'][idx]['controls']
                                  .loanId.value
                              )
                            "
                            >Details
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        class="d-flex mt-3 mb-0 py-2 mx-auto"
        [hidden]="txnsApprovals.length === 0"
      >
        <button
          class="btn btn-info col-4 col-md-2 mx-auto px-0"
          (click)="approveItems()"
        >
          <i class="fas fa-check"></i> Approve
        </button>
        <ngx-spinner class="bg-info" size="medium" type="ball-scale-multiple">
          <p class="text-light">Please wait...</p>
        </ngx-spinner>
        <label class="col" *ngIf="errored" class="text-danger">
          <!-- <i class="material-icons">Cancel</i> -->
          <ngx-alerts></ngx-alerts>
        </label>
        <label class="col" *ngIf="posted" class="text-info">
          <!-- <i class="material-icons">check_circle</i> -->
          <ngx-alerts></ngx-alerts>
        </label>
        <button
          class="btn btn-info col-4 col-md-2 mx-auto px-0"
          (click)="rejectItems()"
        >
          <i class="fas fa-times"></i> Reject
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header bg-info">
    <h4 class="modal-title text-white">Loan Details</h4>

    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="list-card-1 card mt-1 pt-3 mb-0 mx-auto px-0 pb-1 shadow-lg">
      <div class="list-card-body card-body my-0 py-0 mx-0">
        <div class="row my-0 py-0">
          <div class="col-2 col-lg-1 my-0 py-0 mx-0 px-0">
            <!--add checkedLoan from the checkedLoanbase next to the span after &nbsp;-->
            <pinch-zoom class="d-flex justify-content-center">
              <img
                class="img-rounded"
                [src]="checkedLoan.url"
                height="35em"
                width="35em"
                style="border-radius: 40em"
              />
            </pinch-zoom>
          </div>
          <div class="col-10 col-lg-11">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-3 d-flex justify-content-sm-start">
                    <span class="">Client:</span>
                  </div>
                  <div
                    class="col-9 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <span class="itemCreated">{{ checkedLoan.name }}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-5 d-flex justify-content-sm-start">
                    <span class="">Phone No.:</span>
                  </div>
                  <div
                    class="col-7 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <span class="itemCreated">
                      {{ checkedLoan.phone }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-5 col-xl-4 d-flex justify-content-sm-start">
                    <span class="">Loan Purpose:</span>
                  </div>
                  <div
                    class="col-7 col-xl-8 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <span class="itemCreated">
                      {{ checkedLoan.data[0].microloanPurpose }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-5 col-xl-4 d-flex justify-content-sm-start">
                    <span class="">Transaction Date:</span>
                  </div>
                  <div
                    class="col-7 col-xl-8 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <a class="">
                      <span class="itemCreated">{{
                        checkedLoan.data[0].txnDate
                      }}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-5 col-xl-4 d-flex justify-content-sm-start">
                    <span class="">Amortization Type:</span>
                  </div>
                  <div
                    class="col-7 col-xl-8 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <a class="">
                      <span class="itemCreated">{{
                        checkArmotType(checkedLoan.data[0].microloanCustomerAmortType)
                      }}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-5 col-xl-4 d-flex justify-content-sm-start">
                    <span class="">Amortization Cyle:</span>
                  </div>
                  <div
                    class="col-7 col-xl-8 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <span class="itemCreated">
                      {{ checkArmotCycle(checkedLoan.data[0].microloanCustomerAmortCyle) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-5 col-xl-4 d-flex justify-content-sm-start">
                    <span class="">Interest Rate Used:</span>
                  </div>
                  <div
                    class="col-7 col-xl-8 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <a class="">
                      <span class="itemCreated">{{
                        checkedLoan.data[0].interestRateUsed
                      }}%  {{ checkArmotCycle(checkedLoan.data[0].microloanCustomerAmortCyle)}} </span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-5 col-xl-4 d-flex justify-content-sm-start">
                    <span class="">Loan Tenure:</span>
                  </div>
                  <div
                    class="col-7 col-xl-8 d-flex justify-content-sm-start font-weight-bold"
                  >
                    <a class="">
                      <span class="itemCreated">{{
                        checkedLoan.data[0].microloanCustomerLoanTenure
                      }}
                      Day{{checkedLoan.data[0].microloanCustomerLoanTenure > 1 ? 's' : ''}}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let item of checkedLoan.data[1][0]; let i = index">
      <div class="row my-1 py-0">
        <div class="col-12">
          <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
            Guarantor {{ i + 1 }}'s Information
          </h4>
        </div>
      </div>
      <div class="list-card-1 card mt-1 pt-3 mb-0 mx-auto px-0 pb-1 shadow-lg">
        <div class="list-card-body card-body my-0 py-0 mx-0">
          <div class="row my-0 py-0">
            <div class="col-2 col-lg-1 my-0 py-0 mx-0 px-0">
              <!--add checkedLoan from the checkedLoanbase next to the span after &nbsp;-->
              <pinch-zoom class="d-flex justify-content-center">
                <img
                  [src]="item.microLoanGuarantorPhotoUrl"
                  class="img-rounded"
                  height="35em"
                  width="35em"
                  style="border-radius: 40em"
                />
              </pinch-zoom>
            </div>
            <div class="col-10 col-lg-11">
              <div class="row">
                <div class="col-12 col-md-6 col-xl-4">
                  <div class="row">
                    <div class="col-3 col-xl-2 d-flex justify-content-sm-start">
                      <span class="">Name:</span>
                    </div>
                    <div
                      class="col-9 col-xl-10 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <span class="itemCreated">
                        {{ item.microLoanGuarantorName }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4">
                  <div class="row">
                    <div class="col-6 col-md-5 d-flex justify-content-sm-start">
                      <span class="">Phone No.1:</span>
                    </div>
                    <div
                      class="col-6 col-md-7 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <span class="itemCreated">
                        {{ item.microLoanGuarantorPhone1 }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4">
                  <div class="row">
                    <div class="col-6 col-md-5 d-flex justify-content-sm-start">
                      <span class="">Phone No.2:</span>
                    </div>
                    <div
                      class="col-6 col-md-7 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <span class="itemCreated">
                        {{ item.microLoanGuarantorPhone2 }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4">
                  <div class="row">
                    <div class="col-6 col-xl-4 d-flex justify-content-sm-start">
                      <span class="">Business Type:</span>
                    </div>
                    <div
                      class="col-6 col-xl-8 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <a class="">
                        <span class="itemCreated">
                          {{ item.microLoanGuarantorTypeOfBusiness }}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4">
                  <div class="row">
                    <div class="col-6 col-xl-5 d-flex justify-content-sm-start">
                      <!--stage start date-->
                      <span class="">Business Location:</span>
                    </div>
                    <div
                      class="col-6 col-xl-7 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <a class="">
                        <span class="itemCreated">
                          {{ item.microLoanGuarantorBusinessLocation }}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4">
                  <div class="row">
                    <div class="col-6 col-xl-5 d-flex justify-content-sm-start">
                      <span class="">Current Location:</span>
                    </div>
                    <div
                      class="col-6 col-xl-7 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <a class="">
                        <span class="itemCreated">
                          {{ item.microLoanGuarantorPlaceOfResidense }}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let item of checkedLoan.data[1][1]; let i = index">
      <div class="row my-1 py-0">
        <div class="col-12">
          <h5 class="rub-head4 text-info text-center font-weight-bold py-1">
            Security {{ i + 1 }}'s Information
          </h5>
        </div>
      </div>
      <div class="list-card-1 card mt-1 pt-3 mb-0 mx-auto px-0 pb-1 shadow-lg">
        <div class="list-card-body card-body my-0 py-0 mx-0">
          <div class="row my-0 py-0">
            <!-- <div
                  class="col-2 col-xl-1 mt-0 mb-0 pt-0 pt-md-2 pt-xl-0 pb-0 px-xl-0"
                >
                  add checkedLoan from the checkedLoanbase next to the span after &nbsp;
                  <pinch-zoom class="d-flex justify-content-center">
                  <img
                    class="img-rounded"
                    [src]="item.microLoanSecurityPhotoUrl"
                    height="35em"
                    width="35em"
                    style="border-radius: 20em;"
                  />
          </pinch-zoom>
                </div> -->
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="row">
                    <div class="col-5 d-flex justify-content-sm-start">
                      <span class="">Security Type:</span>
                    </div>
                    <div
                      class="col-7 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <span class="itemCreated">
                        {{ item.microLoanSecurityTypeName }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="row">
                    <div class="col-5 d-flex justify-content-sm-start">
                      <span class="">Security Name:</span>
                    </div>
                    <div
                      class="col-7 d-flex justify-content-sm-start font-weight-bold"
                    >
                      <span class="itemCreated">
                        {{ item.microLoanSecurityName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-info col-3 col-xl-2 pull-right"
      (click)="modalRef.hide()"
    >
      Ok
    </button>
  </div>
</ng-template>
